export default "__VITE_ASSET__CcHdfBAL__"